window.MapRoutes = {
  routeInfo: { distance: 0, duration: 0 },
  gmap: null,

  showRoute () {
    let pointFrom = new RoutePoint('from', true)
    let pointTo = new RoutePoint('to', true)

    this.gmap = new GMap('gmap', true)

    if (!pointFrom.positionPoint) return

    this.gmap.setMarker('from', pointFrom.position)

    if (!pointTo.positionPoint) return

    this.gmap.setMarker('to', pointTo.position)

    // Draw the A->B route line (same /api/route_info the edit form uses).
    new Route({
      positionFrom: pointFrom.positionPoint,
      positionTo: pointTo.positionPoint,
    }).getInfo(info => {
      if (info && info.success) this.gmap.setRoute(info)
    })
  },

  getPositionsLatLng: function(from, to) {
    // Google-LatLng-like objects (callers use .lat()/.lng()), no SDK needed.
    const getLatLng = ({ position }) => ({
      lat: () => Number(position[0]),
      lng: () => Number(position[1]),
    })

    return [
      getLatLng(from),
      getLatLng(to)
    ]
  },

  changeMetrics: function(){
    var $routeInfoTable = $('.gmap-table'),
        postfix = $routeInfoTable.data('postfix');
    if (
      $routeInfoTable.length > 0 &&
      postfix &&
      this.routeInfo &&
      this.routeInfo.distance
    ) {
      var $distanceUnit = $('#menu-distance-units .drop-menu-item_selected').data();
      var metric = postfix[$distanceUnit.value];

      var distance = Math.round(this.routeInfo.distance * $distanceUnit.kmRate);

      var minutes = this.routeInfo.duration;
      var hours = minutes / 60;
      var hoursStr = Math.floor(hours);
      var minutesStr = minutes % 60;
      minutesStr = (minutesStr < 10 ? '0' : '') + minutesStr;

      var speed = parseInt(distance / hours);
      var timeStr = [hoursStr, postfix.h, minutesStr, postfix.min].join(' ');
      $('#route_time').text(timeStr);
      $('#route_distance').text(distance + ' ' + metric);
      $('#route_speed').text(speed + ' ' + metric + ' / ' + postfix.h);
      $('.double').toggleClass('show-double', $('#return_way').prop('checked'));
    }
  },

  createArrowIcon: function(fillColor) {
    const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">'
      + '<circle cx="8" cy="8" r="6" fill="' + fillColor + '" stroke="#000" stroke-width="1"/></svg>';
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
  },

  setLocations: function(locations) {
    locations.forEach(location => {
      const coordinates = [Number(location.longitude), Number(location.latitude)];
      new window.mapgl.Marker(this.gmap.map, {
        coordinates,
        icon: this.createArrowIcon(location.state ? '#EE2222' : '#4285F4'),
        size: [16, 16],
        anchor: [8, 8],
      }).on('click', () => {
        let content = '';
        for (const [key, value] of Object.entries(location)) {
          content += `${key} = ${value}<br>`;
        }
        const popup = new window.mapgl.HtmlMarker(this.gmap.map, {
          coordinates,
          html: '<div class="mapgl-popup">' + content + '</div>',
          anchor: [0, 24],
        });
        setTimeout(() => popup.destroy(), 6000);
      });
    })
  },

  errorShowHide: function(id) {
    return function () {
      var $hiddenInput = $('#point' + id);
      var $visibleInput = $hiddenInput.parent().find('.inputTransferPoint');
      $visibleInput.toggleClass('show-error', !$hiddenInput.val());
    };
  },

  setCarrierMarker (coordinates) {
    this.gmap.setCarrierMarker(coordinates);
  },

  destroy () {
    this.gmap.destroy();
  },
};
